{
    "appCore": {
      "common": {
        "yes": "Ja",
        "no": "Nein",
        "errors": {
          "notEmpty": "Dieses Feld darf nicht leer sein"
        }
      },
      "footer": {
        "state": "Nutzungsbedingungen",
        "policy": "Datenschutzrichtlinie"
      },
      "apps": {
        "popUp": {
          "privacyPolicy": {
            "header": "Moment bitte, nur noch das:",
            "text": "Ich erkläre, dass ich die {state} und die {policy} gelesen habe und den Bedingungen zustimme.",
            "state": "Nutzungsbedingungen",
            "policy": "Datenschutzbestimmungen",
            "decline": "Abbrechen",
            "accept": "Ja, ich stimme zu"
          }
        },
        "event": {
          "common": {
            "underPictureText": "Zeigen Sie uns, wie viel Spaß Sie haben, morgen werden wir lachen!",
            "back": "Zurück"
          },
          "mirrorWedding": {
            "sendText": "SENDEN UND DRUCKEN",
            "sendingText": "SENDEN"
          },
          "wedding": {
            "sendText": "SENDEN",
            "sendingText": "SENDEN",
            "1": {
              "sendText": "SENDEN VON FOTOS/VIDEOS"
            }
          },
          "gallery": {
            "header": "Aktuelle Veranstaltungsgalerie!",
            "name": "Galerie",
            "button": "Foto-Galerie",
            "subtext": "Vorschau auf hochgeladene Fotos",
            "moreFiles": "Mehr Fotos",
            "changeView": "Ansicht ändern",
            "loadedFiles": "Dateien geladen",
            "noNewFiles": "Keine neuen Dateien zum Hochladen. Die Bilder in der Galerie werden in zufälliger Reihenfolge angezeigt und erscheinen nicht unbedingt am Ende."
          },
          "sender": {
            "errors": {
              "wrongFiles": "Sie können maximal 20 Fotos oder Videos mit einer Gesamtgröße von bis zu 1 GB senden",
              "wrongFilesWithWish": "Sie können maximal 1 Foto mit einer Gesamtgröße von bis zu 1 GB senden",
              "default": "Fehler beim Senden von Dateien",
              "notFiles": "Keine Dateien ausgewählt"
            },
            "infos": {
              "emptyWish": "Bitte geben Sie Ihre Wünsche ein",
              "sendedFiles": "Alle Dateien gesendet. Vielen Dank :)",
              "sendedProcessing": "Das Video wird nach der Verarbeitung durch den Server in der Galerie angezeigt",
              "fileUnsupported": "Foto erfolgreich geladen. Nach dem Senden finden Sie es in der Galerie.",
              "sendingProblem": {
                "sended": "Gesendet",
                "from": "von",
                "files": "Dateien",
                "checkFiles": "Überprüfen Sie die Datei und senden Sie sie erneut."
              }
            },
            "button": "Fotos/Videos senden",
            "or": "oder",
            "yourWishes": "Ihre Wünsche"
          }
        },
        "rsvp": {
          "versions": {
            "1": {
              "invitationText": "haben die Ehre einzuladen",
              "placeText": "zur Hochzeitszeremonie, die stattfinden wird",
              "yearAndHour": "Jahr um Uhrzeit",
              "in": "in",
              "0": {
                "placeText": "zur Hochzeitszeremonie, die stattfinden wird"
              },
              "1": {
                "placeText": "zur Hochzeitszeremonie und zur Hochzeitsfeier, die stattfinden wird"
              },
              "2": {
                "partyText": "HOCHZEITSFEIER",
                "weddingPlace": "Siehe Kirche auf der Karte",
                "partyPlace": "Siehe Saal auf der Karte"
              }
            },
            "2": {
              "wedding": "Es wird eine Hochzeit geben!",
              "year": "Jahr",
              "hour": "um Uhr",
              "weddingPath": "Klicken Sie hier, um die Route zwischen der Kirche und dem Hochzeitssaal festzulegen:",
              "partyWelcome": "Wir freuen uns bereits darauf, Sie auf unserer Hochzeit willkommen zu heißen!"
            }
          },
          "components": {
            "form": {
              "confirmArrival": "BESTÄTIGEN SIE IHRE ANKUNFT",
              "main": {
                "addAnotherGuest": "Weiteren Gast hinzufügen",
                "addGuest": "Ankunft bestätigen",
                "sendRsvp": "RSVP senden",
                "edit": "BEARBEITEN",
                "name": "VORNAME",
                "surname": "NACHNAME",
                "present": "Ich werde bei der Hochzeit sein",
                "notPresent": "Ich werde nicht bei der Hochzeit sein",
                "notify": {
                  "error": "Fehler beim Senden der Daten",
                  "positive": "Daten gesendet. Vielen Dank :)",
                  "notFilled": "Nicht alle Pflichtfelder wurden ausgefüllt"
                }
              },
              "guest": {
                "guestData": "Geben Sie Ihren Vornamen und Nachnamen ein:",
                "name": "Vorname",
                "surname": "Nachname",
                "willBePresent": "Erscheinen Sie bei unserer Hochzeit?",
                "save": "Speichern"
              },
              "verions": {
                "2": {
                  "historyWish": "Wir möchten, dass Sie Teil unserer gemeinsamen Geschichte werden.",
                  "dueToInfo": "Bitte bestätigen Sie Ihre Anwesenheit bis zum {dueToTime}, indem Sie das untenstehende Formular ausfüllen.",
                  "confirmArrival": "Ankunft bestätigen",
                  "guest": {
                    "guestData": "Geben Sie Ihren Vornamen und Nachnamen ein:",
                    "willBePresent": "Bestätigen Sie Ihre Anwesenheit?"
                  }
                }
              }
            },
            "weddingWishes": {
              "title": "WÜNSCHE DES BRAUTPAARS"
            },
            "clockWidget": {
              "title": "Bis zur Hochzeit verbleiben",
              "clock": {
                "days": "Tage",
                "hours": "Stunden",
                "minutes": "Minuten",
                "seconds": "Sekunden"
              }
            }
          }
        },
        "components": {
          "inputs": {
            "inputCheckboxTrueFalseSelect": {
              "selectLabel": "Wählen Sie eine der folgenden Optionen:"
            }
          },
          "sender": {
            "sendLabel": "Fotos/Videos hinzufügen",
            "sendWithWishLabel": "Fügen Sie ein Foto und Wünsche hinzu",
            "from": "von",
            "processing": "Verarbeitung",
            "notToGallery": "Nicht in der Galerie anzeigen"
          },
          "gks": {
            "findTable": "Finde deinen Tisch"
          }
        },
        "gks": {
          "header": "Sitzplan",
          "foundPlace": "Finde deinen Platz...",
          "namePlaceholder": "Gib deinen Namen ein",
          "personNotFound": "Person nicht gefunden",
          "samePersonFound": "Es wurden mehr Personen mit einem ähnlichen Namen gefunden, bitte weiter eingeben...",
          "table": "Tisch",
          "footer": "...Und dann feier bis zum Morgengrauen!"
        }
      }
    },
  
    "loremIpsum": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,"
  }  
